import { OctGenerateForm } from '@oceantech/oceantech-ui';
import { Form, Formik, FormikProps } from 'formik';
import { useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import useFormio from 'src/app/hook/useFormio';
import { ServiceTemplateButton } from '../../phan-he-kham-benh/components/service-template-button';
import { parseJSON } from '../../utils/FormatUtils';
import { GenerateFormModalProps } from './types';

const GenerateFormModal = ({
	open,
	title,
	onClose,
	onSave,
	termModel,
	itemEdit,
}: GenerateFormModalProps) => {
	const { formJSON } = useFormio({
		code: termModel,
	});

	const { formJSON: prescriptionFormExpand } = useFormio({
		code: itemEdit?.attributes?.prescriptionFormExpand,
	});

	const formikRef = useRef<FormikProps<any>>(null);

	useEffect(() => {
		if (itemEdit) {
			formikRef.current?.setValues({
				forms: itemEdit?.obs
			});
		}
	}, []);

	const handleSubmit = (values: any) => {
		let submitData = {
			...values.forms,
		}
		onSave(submitData);
	};

	return (
		<Modal show={open} onHide={onClose} size="lg" centered scrollable>
			<Modal.Header closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Formik<{
				forms: any;
			}>
				initialValues={{
					forms: null,
				}}
				onSubmit={handleSubmit}
				innerRef={formikRef}
			>
				{({ values, setFieldValue, errors, touched }) => (
					<Form>
						<Modal.Body className="spaces pt-8 min-h-150px">
							<div className='d-flex flex-end'>
								<ServiceTemplateButton
									label="Mẫu thông tin bổ sung"
									getSaveParams={() => ({
										orderTemplate: JSON.stringify(values.forms),
										termId: itemEdit?.id
									})}
									searchParams={{ termId: itemEdit?.id }}
									onSelectMau={(data) => {
										setFieldValue('forms', parseJSON(data?.orderTemplate));
									}}
								/>
							</div>
							<OctGenerateForm
								listFieldAuto={formJSON}
								setFieldValue={setFieldValue}
								values={values}
								modelID="forms"
								errors={errors}
								touched={touched}
							/>
							{prescriptionFormExpand && (
								<OctGenerateForm
									listFieldAuto={prescriptionFormExpand}
									setFieldValue={setFieldValue}
									values={values}
									modelID="forms"
									errors={errors}
									touched={touched}
								/>
							)}
						</Modal.Body>
						<Modal.Footer className="gap-2">
							<Button variant="danger" onClick={onClose}>
								Đóng
							</Button>
							<Button type="submit">Lưu</Button>
						</Modal.Footer>
					</Form>
				)}
			</Formik>
		</Modal>
	);
};

export default GenerateFormModal;
